import { render, staticRenderFns } from "./ResourceComments.vue?vue&type=template&id=2bd116e9&scoped=true&"
import script from "./ResourceComments.vue?vue&type=script&lang=js&"
export * from "./ResourceComments.vue?vue&type=script&lang=js&"
import style0 from "./ResourceComments.vue?vue&type=style&index=0&id=2bd116e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd116e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VIcon,VSpacer,VTextarea})
